import React, { useEffect, useRef } from "react";

const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const boxStyle = {
  background: "#fff",
  borderRadius: "8px",
  padding: "2rem",
  maxWidth: "90vw",
  boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
  textAlign: "center",
};

export default function CartUnavailableModal({ open, onClose }) {
  const okButtonRef = useRef(null);
  const modalRef = useRef(null);

  // Focus trap and initial focus
  useEffect(() => {
    if (!open) return;
    const previouslyFocused = document.activeElement;
    if (okButtonRef.current) okButtonRef.current.focus();

    function handleKeyDown(e) {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
      // Focus trap: only the OK button is focusable
      if (e.key === "Tab") {
        e.preventDefault();
        if (okButtonRef.current) okButtonRef.current.focus();
      }
    }

    document.addEventListener("keydown", handleKeyDown, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      if (previouslyFocused && previouslyFocused.focus) {
        previouslyFocused.focus();
      }
    };
  }, [open, onClose]);

  if (!open) return null;
  const message =
    "An item in your cart is no longer available and has been removed.";
  return (
    <div
      data-testid="cart-unavailable-modal"
      style={modalStyle}
      role="dialog"
      aria-modal="true"
      aria-labelledby="cart-unavailable-title"
      aria-describedby="cart-unavailable-desc"
      ref={modalRef}
    >
      <div style={boxStyle}>
        <h2 id="cart-unavailable-title" style={{ fontSize: "2rem" }}>
          Some items were removed from your cart
        </h2>
        <p id="cart-unavailable-desc">{message}</p>
        <button
          className="py-2 px-6 rounded-full font-bold bg-indigo-600 text-white hover:bg-indigo-700 transition"
          style={{
            marginTop: "1.5rem",
            fontSize: "1rem",
          }}
          onClick={onClose}
          ref={okButtonRef}
        >
          OK
        </button>
      </div>
    </div>
  );
}
